import * as React from 'react';
export const fedexSvg = React.forwardRef(function fedexSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm27.578 19.723-1.105-1.181-1.094 1.181h-2.304l2.251-2.413-2.251-2.414h2.375l1.116 1.173 1.074-1.173h2.292l-2.24 2.404 2.27 2.423zm-8.926 0V12.12h4.423v1.695h-2.55v1.082h2.55v1.631h-2.55v1.497h2.55v1.7z',
        fill: '#ff5a00',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16.785 12.12v3.111h-.02c-.414-.453-.93-.61-1.529-.61-1.227 0-2.15.796-2.475 1.847-.37-1.159-1.324-1.87-2.74-1.87-1.148 0-2.055.492-2.53 1.294v-.996H5.118v-1.082H7.71V12.12H3v7.604h2.117v-3.196h2.11a2.905 2.905 0 0 0-.097.752c0 1.585 1.27 2.7 2.891 2.7 1.363 0 2.262-.612 2.737-1.724h-1.814c-.245.335-.432.434-.922.434-.569 0-1.06-.474-1.06-1.035h3.694c.16 1.26 1.19 2.346 2.601 2.346.609 0 1.166-.286 1.507-.768h.02v.492h1.867V12.12h-1.866zm-7.764 4.43c.118-.483.51-.8 1-.8.54 0 .913.307 1.01.8zm6.631 2.016c-.687 0-1.115-.611-1.115-1.25 0-.683.372-1.338 1.115-1.338.772 0 1.079.656 1.079 1.338 0 .647-.325 1.25-1.079 1.25z',
        fill: '#29007c',
      }),
    ),
  );
});
fedexSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fedex = {
  category: 'brand',
  colorable: false,
  name: 'fedex',
  svg: fedexSvg,
};
